import client, { API_BASE_URL } from './client';

// QR오더 화면(고객용, 인증 불필요)에서 쓰던 직원호출 요청/조회 함수들은 front-web(고객용
// 웹서비스)의 api/qrOrder.js 로 이관되었다 - 화면 자체가 그쪽으로 옮겨갔기 때문이다.
// 아래는 관리자 전용 함수만 남는다.

// ===================== 관리자용 =====================

export async function getTableCallList(params) {
  const res = await client.get('/admin/table-call', { params });
  return res.data;
}

export async function getTableCall(callId) {
  const res = await client.get(`/admin/table-call/${callId}`);
  return res.data;
}

export async function updateTableCallStatus(callId, callStatus, updatedBy) {
  const res = await client.put(`/admin/table-call/${callId}/status`, { callStatus, updatedBy });
  return res.data;
}

/** 사이드바 뱃지/대시보드용 - 아직 처리되지 않은 호출 건수 */
export async function getPendingCallCount() {
  const res = await client.get('/admin/table-call/dashboard/pending-count');
  return res.data;
}

/**
 * 직원호출관리 목록화면 실시간 갱신용 SSE 스트림 URL. 브라우저 EventSource 는 커스텀
 * 헤더(Authorization)를 보낼 수 없으므로, JWT를 "?token=" 쿼리파라미터로 실어보낸다
 * (서버 JwtAuthenticationFilter 가 헤더가 없을 때 이 쿼리파라미터를 대체 수단으로 허용한다).
 */
export function tableCallStreamUrl(accessToken) {
  return `${API_BASE_URL}/admin/table-call/stream?token=${encodeURIComponent(accessToken || '')}`;
}
